import mainService from "./mainService";
const path = "writer/quizzes";

export function record() {
    return mainService
        .get(path + "/record/")
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}
export function start() {
    return mainService
        .get(path + "/start/")
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}
export function retry() {
    return mainService
        .get(path + "/retry")
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}
export function lostFocus() {
    return mainService
        .get(path + "/lostFocus/")
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}
export function timeOut() {
    return mainService
        .get(path + "/timeOut/")
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}
export function save(data) {
    console.log(data);
    return mainService
        .post(path + "/save", data)
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}



// WEBPACK FOOTER //
// ./src/services/quiz.jsx